import React, {Component, useState} from 'react';
import axios from "axios";
import DataTable from "react-data-components/lib/DataTable";
import { DataGrid } from 'tubular-react';
import { ColumnModel } from 'tubular-common'
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import translations from '../Translations'


import * as ROUTES from '../../constants/routes';

import AddIcon from '@material-ui/icons/Add';
import IconButton from '@material-ui/core/IconButton';
// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


import { TbRow, TbRowProps } from "tubular-react";

import SmartDataTable from 'react-smart-data-table'
import ModalExample from "./ModalExample";
import {Spinner} from "react-bootstrap";
import { css } from "@emotion/core";
// First way to import
// Another way to import. This is recommended to reduce bundle size
import ClipLoader from "react-spinners/ClipLoader";
import { ClockLoader} from "react-spinners";
import filterFactory, {selectFilter, textFilter, numberFilter} from "react-bootstrap-table2-filter";
import {BACKEND_BASE_URL} from "../../constants/routes";
// const rowClick = () => {
//     console.log("You clicked on a row!");
// };


const rowEvents = {
    onClick: (e, row, rowIndex) => {
        console.log(row)
        axios.post(`${BACKEND_BASE_URL}/users/enableWorker`, {
            email:row.email
        }).then(result=>{
            this.fetchData()

            // console.log(result.data.message)
            alert(result.data.message)
        })
            .catch(e=>{
                console.log(e)
            })
    }
}
const paginationOption = {
    custom: true,
    totalSize: 3
};
const status = {
    'enabled': 'Enabled',
    'disabled' : 'Disabled',
};

const houseType = {
    'enabled': 'Enabled',
    'disabled' : 'Disabled',
};
// Can be a string as well. Need to ensure each key-value pair ends with ;
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

class DisableWorker extends Component {

    constructor(props) {
        super(props);
        this.state = { allWorkers: [], localData: [],  loading: true}
        this.fetchDetails = this.fetchDetails.bind(this)
        this.onRowClick = this.onRowClick.bind(this)
        this.showModal = this.showModal.bind(this)
        this.rowEvents.onClick = this.rowEvents.onClick.bind(this)


    }
     columnsTable = [{
        dataField: 'email',
        text: translations.email[this.props.user.language]
    },
        {
            dataField: 'phone',
            text: 'Worker\'s phone',
            filter: textFilter()
        },{
            dataField: 'firstName',
            text: 'Worker\'s Name',
            filter: textFilter()
        },

        {
            dataField: 'jobsCompleted',
            text: translations.jobs_completed[this.props.user.language],
            // formatter: cell => selectOptions[cell],
            filter: numberFilter()
        },
        // {
        //     dataField: 'type',
        //     text: 'House Type',
        //     formatter: cell => houseType[cell],
        //     filter: selectFilter({
        //         options: houseType
        //     })
        // },
        {
            dataField: 'availableBalance',
            text: translations.commissions_pay[this.props.user.language],
            filter: numberFilter()
        },
        {
            dataField: 'status',
            text: 'Status',
            formatter : cell => houseType[cell],
            filter: selectFilter({
                options: houseType
            })
        }
    ];




    state = { show: false };

    fetchData(){
        axios.get(`${BACKEND_BASE_URL}/users/allWorkers`).then(
            allWorkers => {
                this.setState({loading:false})
                // console.log(jobHistories.data.data)
                allWorkers.data.data.forEach(history=>{
                    var utcSeconds = history.date
                    var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
                    d.setUTCSeconds(utcSeconds);
                    history.convertedDate = d.toGMTString()
                })
                console.log(allWorkers.data.data)
                this.setState({localData: allWorkers.data.data})

            }
        ).catch(e => {
            this.setState({loading:false})
            console.log(e)
        })

    }


    rowEvents = {
        onClick (e, row, rowIndex) {
            this.setState({loading:true})
            axios.post(`${BACKEND_BASE_URL}/users/enableWorker`, {
                email:row.email
            }).then(result=>{
                this.fetchData()

                // console.log(result.data.message)
                alert(result.data.message)
            })
                .catch(e=>{
                    this.setState({loading:false})
                    console.log(e)
                })

        }
    }



    showModal = (e) => {
        this.setState({loading:true})
        // console.log(e)
        this.setState({ show: true });
        var person = this.state.localData.filter((value)=> value.email === e.email)
        console.log(person[0])
        axios.post(`${BACKEND_BASE_URL}/users/enableWorker`, {
            email:person[0].email
        }).then(result=>{
            this.fetchData()

            // console.log(result.data.message)
            alert(result.data.message)
        })
            .catch(e=>{
                this.setState({loading:false})
                console.log(e)
            })
        // this.state.localData.map((worker)=> worker.email === e.email )
        // alert("Your file is being uploaded!")
    };

    hideModal = () => {
        this.setState({ show: false });
    };


    onRowClick() {
        this.setState({ show: true })
            console.log("0-0-j0-j-0")

    }



    columns = [new ColumnModel('email',  {
        filterable: true,
        searchable: true,
        sortable: true
    }),new ColumnModel('accountName', {
        filterable: true,
        searchable: true,
        sortable: true
    }), new ColumnModel('jobsCompleted', {
        filterable: true,
        searchable: true,
        sortable: true
    }), new ColumnModel('availableBalance',  {
        filterable: true,
        searchable: true,
        sortable: true
    }), new ColumnModel('status',  {
        filterable: true,
        searchable: true,
        sortable: true
    })];






    componentDidMount() {
        if (this.props.user.access != "Admin"){
            this.props.setError("You Lack Required Access To this Page")
            this.props.history.push("/error")
        }else this.fetchData()


    }

    fetchDetails(e){
        console.log("jajajaja")
    }
    render() {
        let data = this.state.allWorkers
        return (
            <div>

                {/*<Button variant="primary"*/}
                {/*        // onClick={handleShow}*/}
                {/*>*/}
                {/*    Launch demo modal*/}
                {/*</Button>*/}

                {/*<Modal show={true}*/}
                {/*       // onHide={handleClose}*/}
                {/*>*/}
                {/*    <Modal.Header closeButton>*/}
                {/*        <Modal.Title>Modal heading</Modal.Title>*/}
                {/*    </Modal.Header>*/}
                {/*    <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>*/}
                {/*    <Modal.Footer>*/}
                {/*        <Button variant="secondary"*/}
                {/*                // onClick={handleClose}*/}
                {/*        >*/}
                {/*            Close*/}
                {/*        </Button>*/}
                {/*        <Button variant="primary"*/}
                {/*                // onClick={handleClose}*/}
                {/*        >*/}
                {/*            Save Changes*/}
                {/*        </Button>*/}
                {/*    </Modal.Footer>*/}
                {/*</Modal>*/}
                {/*<SmartDataTable*/}
                {/*    data={this.state.localData}*/}
                {/*    name='test-table'*/}
                {/*    className='ui compact selectable table'*/}
                {/*    onClick={this.onRowClick}*/}
                {/*    onRowClick={this.showModal}*/}
                {/*    sortable*/}
                {/*/>*/}

                <div className="sweet-loading">
                    <ClockLoader
                        css={override}
                        size={100}
                        //size={"150px"} this also works
                        color={"#123abc"}
                        loading={this.state.loading}
                    />
                </div>

                {/*<DataGrid columns={this.columns} dataSource={this.state.localData} gridName="Grid"onRowClick={this.showModal}/>*/}
                {/*<PaginationProvider*/}
                {/*    pagination={ paginationFactory(paginationOption) }*/}
                {/*>*/}
                {/*    {*/}
                {/*        ({*/}
                {/*             paginationProps,*/}
                {/*             paginationTableProps*/}
                {/*         }) => (*/}
                {/*            <div>*/}
                                <BootstrapTable keyField='index' data={ this.state.localData } columns={ this.columnsTable } filter={ filterFactory() }   striped
                                                hover
                                                condensed  rowEvents={ this.rowEvents }  pagination={ paginationFactory()} />
                {/*            </div>*/}
                {/*        )*/}
                {/*    }*/}
                {/*</PaginationProvider>*/}

                {/*/!*</DataGrid>*!/*/}

                {/*<Modal handleClose={this.hideModal} show={this.state.show}>*/}
                {/*    <p>Modal</p>*/}
                {/*    <p>Data</p>*/}
                {/*</Modal>*/}

                {/*<button type="button" onClick={this.showModal}>*/}
                {/*    open*/}
                {/*</button>*/}


            </div>
        );
    }
}

export default DisableWorker;